<script>
import { VueFinalModal } from 'vue-final-modal'
import { ref } from "vue";

export default {
    components: {
        VueFinalModal
    },
    props: {
        title: String,
        subtitle: String,
        size: String
    },
    data() {
        return {
            modalClass: ref(`vue-modal-${this.size}`)
        }
    },
    emits: ['confirm']
}
</script>

<template>
    <VueFinalModal class="flex justify-center items-center" :class="[modalClass]" :reserve-scroll-bar-gap="true" :reserveScrollBarGap="true" content-class="card mx-md-auto">
        <h3 class="modal-title vue-modal-title">{{ title }}</h3>
        <h4 class="modal-subtitle">{{ subtitle }}</h4>
        <button class="modal-dismiss" @click="$emit('confirm')"></button>
        <div class="modal-body">
            <slot />
        </div>
    </VueFinalModal>
</template>
